/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logout_From_Account_AutoInputs */

const en_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll be automatically logged-out of account.brave.com`)
};

const id_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan secara otomatis logout dari account.brave.com`)
};

const ms_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan dilog keluar secara automatik daripada account.brave.com`)
};

const ca_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es tancarà automàticament la sessió d'account.brave.com`)
};

const cs_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budete automaticky odhlášeni z account.brave.com.`)
};

const da_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bliver automatisk logget ud af account.brave.com`)
};

const de_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du wirst automatisch abgemeldet von account.brave.com`)
};

const et_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teid logitakse automaatselt veebilehelt account.brave.com välja.`)
};

const es_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sesión se cerrará automáticamente en account.brave.com`)
};

const fr_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous serez automatiquement déconnecté(e) de account.brave.com.`)
};

const hr_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatski ćete biti odjavljeni iz account.brave.com`)
};

const it_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sarai automaticamente disconnesso da account.brave.com`)
};

const lv_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūs automātiski izrakstīsieties no vietnes account.brave.com`)
};

const lt_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Būsite automatiškai atjungti nuo account.brave.com`)
};

const hu_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatikusan kijelentkezik az account.brave.com webhelyről`)
};

const nl_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je wordt automatisch uitgelogd bij account.brave.com`)
};

const nb_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du logges ut av account.brave.com automatisk`)
};

const pl_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje konto zostanie automatycznie wylogowane z account.brave.com`)
};

const pt_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você será automaticamente desconectado da conta account.brave.com`)
};

const ro_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vei fi deconectat automat din cont.brave.com`)
};

const sk_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budete automaticky odhlásení z account.brave.com`)
};

const sl_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samodejno boste odjavljeni iz računa account.brave.com.`)
};

const fi_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinut kirjaudutaan automaattisesti ulos sivulta account.brave.com`)
};

const sv_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kommer automatiskt att loggas ut från account.brave.com`)
};

const vi_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn sẽ được tự động đăng xuất tài khoản account.brave.com`)
};

const tr_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`account.brave.com adresinden otomatik olarak çıkış yapacaksınız`)
};

const el_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Θα αποσυνδεθείτε αυτόματα από το account.brave.com`)
};

const bg_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Така автоматично ще излезеш от account.brave.com`)
};

const ru_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы автоматически выйдете из системы account.brave.com`)
};

const sr_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аутоматски ћете бити одјављени са account.brave.com`)
};

const uk_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви автоматично вийдете з account.brave.com`)
};

const ka_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენ ავტომატურად გამოხვალთ account.brave.com-დან`)
};

const hi_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप ऑटोमेटिकली account.brave.com से लॉगआउट हो जाएंगे`)
};

const th_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณจะถูกออกจากระบบโดยอัตโนมัติจาก account.brave.com`)
};

const ko_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`account.brave.com에서 자동으로 로그아웃됩니다`)
};

const zh_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您将会自动登出 account.brave.com`)
};

const zh_tw_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您將自動登出 account.brave.com`)
};

const ja_logout_from_account_auto = /** @type {(inputs: Logout_From_Account_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`account.brave.comから自動的にログアウトされます。`)
};

/**
* | output |
* | --- |
* | "You'll be automatically logged-out of account.brave.com" |
*
* @param {Logout_From_Account_AutoInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const logout_from_account_auto = /** @type {((inputs?: Logout_From_Account_AutoInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logout_From_Account_AutoInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_logout_from_account_auto(inputs)
	if (locale === "ms") return ms_logout_from_account_auto(inputs)
	if (locale === "ca") return ca_logout_from_account_auto(inputs)
	if (locale === "cs") return cs_logout_from_account_auto(inputs)
	if (locale === "da") return da_logout_from_account_auto(inputs)
	if (locale === "de") return de_logout_from_account_auto(inputs)
	if (locale === "et") return et_logout_from_account_auto(inputs)
	if (locale === "es") return es_logout_from_account_auto(inputs)
	if (locale === "fr") return fr_logout_from_account_auto(inputs)
	if (locale === "hr") return hr_logout_from_account_auto(inputs)
	if (locale === "it") return it_logout_from_account_auto(inputs)
	if (locale === "lv") return lv_logout_from_account_auto(inputs)
	if (locale === "lt") return lt_logout_from_account_auto(inputs)
	if (locale === "hu") return hu_logout_from_account_auto(inputs)
	if (locale === "nl") return nl_logout_from_account_auto(inputs)
	if (locale === "nb") return nb_logout_from_account_auto(inputs)
	if (locale === "pl") return pl_logout_from_account_auto(inputs)
	if (locale === "pt") return pt_logout_from_account_auto(inputs)
	if (locale === "ro") return ro_logout_from_account_auto(inputs)
	if (locale === "sk") return sk_logout_from_account_auto(inputs)
	if (locale === "sl") return sl_logout_from_account_auto(inputs)
	if (locale === "fi") return fi_logout_from_account_auto(inputs)
	if (locale === "sv") return sv_logout_from_account_auto(inputs)
	if (locale === "vi") return vi_logout_from_account_auto(inputs)
	if (locale === "tr") return tr_logout_from_account_auto(inputs)
	if (locale === "el") return el_logout_from_account_auto(inputs)
	if (locale === "bg") return bg_logout_from_account_auto(inputs)
	if (locale === "ru") return ru_logout_from_account_auto(inputs)
	if (locale === "sr") return sr_logout_from_account_auto(inputs)
	if (locale === "uk") return uk_logout_from_account_auto(inputs)
	if (locale === "ka") return ka_logout_from_account_auto(inputs)
	if (locale === "hi") return hi_logout_from_account_auto(inputs)
	if (locale === "th") return th_logout_from_account_auto(inputs)
	if (locale === "ko") return ko_logout_from_account_auto(inputs)
	if (locale === "zh") return zh_logout_from_account_auto(inputs)
	if (locale === "zh-tw") return zh_tw_logout_from_account_auto(inputs)
	if (locale === "ja") return ja_logout_from_account_auto(inputs)
	return en_logout_from_account_auto(inputs)
});